import { WRITE_API_URL } from "../config/site";

const MAX_FILES_PER_REQUEST = 10;
const MAX_FILES_PER_CART_ITEM = 30;
const MAX_FILE_BYTES = 15 * 1024 * 1024;
const ALLOWED_IMAGE_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/webp",
]);

function validateFiles(files) {
  if (files.length > MAX_FILES_PER_CART_ITEM) {
    throw new Error(
      `Solo se permiten ${MAX_FILES_PER_CART_ITEM} imágenes por producto.`
    );
  }

  files.forEach((file) => {
    if (!ALLOWED_IMAGE_TYPES.has(file.type)) {
      throw new Error(
        `${file.name}: formato no permitido. Usa JPG, PNG o WebP.`
      );
    }

    if (file.size <= 0 || file.size > MAX_FILE_BYTES) {
      throw new Error(`${file.name}: cada imagen puede ocupar como máximo 15 MB.`);
    }
  });
}

async function uploadFileBatch({ cartItemId, files }) {
  const formData = new FormData();

  formData.append("cartItemId", cartItemId);

  files.forEach((file) => {
    formData.append("files[]", file, file.name);
  });

  const response = await fetch(`${WRITE_API_URL}/upload-cart-files.php`, {
    method: "POST",
    body: formData,
  });

  const text = await response.text();

  let data;

  try {
    data = JSON.parse(text);
  } catch (error) {
    console.error("Respuesta PHP no JSON:", text);
    throw new Error("Error PHP. Revisa la respuesta del servidor.");
  }

  if (!response.ok || !data.ok) {
    throw new Error(data.error || "No se pudieron subir las imagenes.");
  }

  return data.files || [];
}

export async function uploadCartTempFiles({ cartItemId, files }) {
  validateFiles(files);

  const uploadedFiles = [];

  for (
    let index = 0;
    index < files.length;
    index += MAX_FILES_PER_REQUEST
  ) {
    const batch = files.slice(index, index + MAX_FILES_PER_REQUEST);
    const batchFiles = await uploadFileBatch({ cartItemId, files: batch });

    uploadedFiles.push(...batchFiles);
  }

  return uploadedFiles;
}
